import React, { useState } from 'react';
import { API_BASE_URL, GraphicTypeContainers, renderModal, closeModal, ChartWidget, ListWithDatasetSelector} from './Common';
import './ChartWidgetCreator.css';
import axios from 'axios';

function ChartWidgetCreator({
  tableColumnData,
  isTablesLoaded,
  tables,
  projectId,
  setWidgets
}) {

  const [selectedDatasets, setselectedDatasets] = useState([]);
  const [selectedTable, setSelectedTable] = useState('');
  const [selectedColumn, setSelectedColumn] = useState('');
  const [graphType, setGraphType] = useState('');
  const [newWidgetName, setnewWidgetName] = useState('');

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalMessageColor, setModalMessageColor] = useState('');
  const [modalIconId, setModalIconId] = useState(1);

const handleCreateWidget = async () => {
  try {
    const token = localStorage.getItem('token');

const newWidgetData = {
      projectId: projectId,
      graphType: graphType,
      label: selectedColumn,
      name: newWidgetName,
      dataset: selectedDatasets
    };

    const response = await axios.post(`${API_BASE_URL}/widgets`, newWidgetData, {
      headers: {
        Authorization: `Bearer ${token}` // Include JWT token in Authorization header
      }
    });

    const firstKey = Object.keys(response.data.duplicatedWidget)[0];
    const newWidget = response.data.duplicatedWidget[firstKey];

    setWidgets(prevWidgets => ({ ...prevWidgets, [firstKey]: newWidget }));

    setModalMessage("Widget criado!");
      setModalMessageColor('#41BBC9');
      setModalIconId(1);
      setIsModalOpen(true);

  } catch (error) {
    setModalMessage("Widget com erros...");
      setModalMessageColor('#E5004E');
      setModalIconId(2);
      setIsModalOpen(true);
  }
};


  return (
  <div className="home-container" style={{ paddingLeft: '0px', paddingTop: '0px' }}>
      <h2>Gerir widgets</h2>
      <p>Criar widget</p>

    <div className="create-project">
          <label className="project-name-label">Nome do Widget</label>
    <input
    type="text"
    placeholder="Inserir nome do widget"
    onChange={(e) => setnewWidgetName(e.target.value)}
    />

    <ListWithDatasetSelector
      data={tables}
      selectedData={selectedTable}
      setSelectedData={setSelectedTable}
      isDataLoaded={isTablesLoaded}
      selectedColumn={selectedColumn}
      setSelectedColumn={setSelectedColumn}
      selectedDatasets={selectedDatasets}
      setSelectedDatasets={setselectedDatasets}
    />

<GraphicTypeContainers
          selectedDatasets={selectedDatasets}
          tableColumnData={tableColumnData}
          setGraphType={setGraphType}
          graphType={graphType}
        />

    <ChartWidget
  tables={tables}
  tableColumnData={tableColumnData}
  graphType={graphType}
  selectedColumn={selectedColumn}
  selectedDatasets={selectedDatasets}

  buttonLabel="Guardar Widget"
  onButtonClick={handleCreateWidget}
/>

  </div>

{renderModal(isModalOpen, modalMessage, closeModal(setIsModalOpen), modalMessageColor, modalIconId)}
  </div>
);

}



export default ChartWidgetCreator;
